import { Component } from '@angular/core';
import { data } from 'src/environments/data';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'portail-perso';
  data = data;
}
